import React, { useState, useRef } from 'react';
import styles from '../css/Upload.module.css';
import Sidebar from './Sidebar';
import { Navigate } from 'react-router-dom';
import { uploadImage } from '../service/apiService';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import constant from '../service/constants.js';
const api = constant.api
const UploadPage = () => {
  const [imageFile, setImageFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [fileName, setFileName] = useState('');
  const [activeSection, setActiveSection] = useState('upload');
  const [processedData, setProcessedData] = useState(null); // Store processed result data
  const token = localStorage.getItem('token');
  const fileInputRef = useRef();
  const [displayName,setDisplayName]=useState(null);
  const [image,setImage] =  useState(null)
  const [modalImage, setModalImage] = useState(null);

  // Handle file selection
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setImageFile(file);
    setFileName(file ? file.name : '');
    setProcessedData(null); // Clear previous processed data if new file is selected
  };

  const openModal = (imageSrc) => {
    setModalImage(imageSrc);
  };
  
  const closeModal = () => {
    setModalImage(null);
  };
  
  // Handle image upload
  const handleUpload = async () => {
    if (!imageFile) return;
    if (imageFile.type !== 'image/png' && imageFile.type !== 'image/jpg' && imageFile.type !== 'image/jpeg') {
      toast.error('Only PNG & JPG files are allowed.');
      return;
    }
    setLoading(true);
    try {
      // Send image to backend for processing
      const formData = new FormData();
      formData.append('image', imageFile);

      const response = await uploadImage( imageFile);

      // Store processed result data from backend
      setImage(response.resultPath)
      setDisplayName(response.displayName)
      setProcessedData(response.result);
      toast.success('Image uploaded and processed successfully!');
    } catch (err) {
      toast.error('Failed to upload image.');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  // Check if user is logged in
  if (!token) {
    return <Navigate to="/login" />;
  }

  return (
    <div className={styles.dashboard}>
      <Sidebar activeSection={activeSection} setActiveSection={setActiveSection} />
      <div className={styles.content}>
        {/* === Step 1: Upload === */}
        {!processedData && (
        <div className={styles.card}>
          <h3 className={styles.uploadTitle}>Add Image</h3>
          <p className={styles.uploadDescription}>
            Add your image here, and you can upload one at a time.
          </p>
          <div className={styles.uploadArea}>
            <label htmlFor="file-upload" className={styles.uploadAreaLabel}>
              <input
                type="file"
                id="file-upload"
                accept=".png,.jpg,.jpeg"
                onChange={handleFileChange}
                ref={fileInputRef}
                className={styles.hiddenFileInput}
              />
              <p className={styles.uploadInstructions}>
                {!fileName ? (
                  <>
                    Drag your file(s) to start uploading
                    <br />
                    <span>OR</span>
                    <br />
                    Browse files
                  </>
                ) : (
                  <span>Selected File: {fileName}</span>
                )}
              </p>
            </label>
          </div>
          <p className={styles.supportedFileTypes}>Only support .jpg .png images</p>

          {/* Upload Button */}
          <button
            onClick={handleUpload}
            disabled={!imageFile || loading}
            className={styles.uploadButton}
          >
            {loading ? 'Processing...' : 'Upload Image'}
          </button>
        </div>
        )}
        {/* === Step 3: Display Processed Result === */}
        {processedData && (
          <div className={styles.card}>
          <h3 className={styles.uploadTitle}>Image Processed Result</h3>
          <p><strong>Display Name:</strong> {displayName}</p>
          <img
            src={`${api}/${image}`}
            alt="Original"
            className={styles.previewImage}
            onClick={() => openModal(`${api}/${image}`)}
          />

          {/* BLIP Caption */}
          <p><strong>BLIP Caption:</strong> {processedData.blip_caption}</p>

          <div className={styles.resultsGrid}>
           
            {/* ResNet50 Classification */}
            <div className={styles.resultSection}>
              <h4 className={styles.resultHeader}>ResNet50 Classification</h4>
              <div className={styles.resultList}>
                {processedData.resnet50_classification.map((item, index) => {
                  const [label, value] = item.split(':');
                  return (
                    <div key={index}>
                      <strong>{label.trim()}</strong>: {parseFloat(value).toFixed(4)}
                    </div>
                  );
                })}
              </div>
            </div>
        
            {/* YOLOv5 Detections */}
            <div className={styles.resultSection}>
              <h4 className={styles.resultHeader}>YOLOv5 Detections</h4>
              <div className={styles.resultList}>
                {processedData.yolov5_detections.map((item, index) => {
                  const [label, value] = item.split(':');
                  return (
                    <div key={index}>
                      <strong>{label.trim()}</strong>: {parseFloat(value).toFixed(4)}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        
          <button
            className={styles.uploadButton}
            onClick={() => {
              setImageFile(null);
              setFileName('');
              setProcessedData(null);
            }}
          >
            Upload Another Image
          </button>
        </div>
        
        )}
        {modalImage && (
        <div className={styles.modalOverlay} onClick={closeModal}>
          <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
            <img src={modalImage} alt="Full View" className={styles.modalImage} />
            <button onClick={closeModal} className={styles.closeButton}>Close</button>
          </div>
        </div>
      )}
      </div>

    </div>
  );
};

export default UploadPage;
